<template>
  <div class="QuotationSummaryWrapper">
    <div class="summaryQuotation">
      <div class="summaryQuotation__header">
        <div class="summaryQuotation__header__left">
          <div class="back" @click.stop="goToQuotationList()">
            <div>
            <span class="back__icon strong"><i class="adx-ic_arrow_left"></i></span>
            <span class="back__all subhead color-pink">All Quotation</span>
            </div>
          </div>
          <div class="title">
            <h1 class="medium-title">Campaign Quotation</h1>
            <label class="subhead">Detail Of Campaign Quotation</label>
          </div>
        </div>
        <div class="summaryQuotation__header__right">
          <button type="button" class="secondary btn-small edit" @click="goEditQuotation">Edit</button>
          <button type="button" class="secondary btn-small print" :disabled="true">Print</button>
          <button type="button" class="secondary btn-small request" :disabled="true">Request Discount</button>
        </div>
      </div>
      <div v-if="isLoadingMain">
        <adx-loading/>
      </div>
      <div v-else  class="summaryQuotation__body">
        <div class="summaryQuotation__body__header">
          <div class="summaryQuotation__body__header__no-quotation">
            <div class="summaryQuotation__body__header__no-quotation__quotation-number">
              <div class="default-heigh title mini-font color-grey bold ">QUOTATION NAME</div>
              <div class="subhead strong default-heigh">{{model.quotationName}}</div>
              <div class="subhead default-heigh">{{model.number}}</div>
            </div>
            <div class="summaryQuotation__body__header__no-quotation__quotation-date">
              <div class="title default-heigh mini-font color-grey bold">ISSUE DATE</div>
              <div class="subhead default-heigh">{{model.issueDate}}</div>
            </div>
            <div class="summaryQuotation__body__header__no-quotation__quotation-date">
              <div class="title default-heigh mini-font color-grey bold">DISCOUNT STATUS</div>
              <div class="subhead default-heigh">{{'-'}}</div>
            </div>
          </div>
          <div class="summaryQuotation__body__header__recipient">
            <div class="title default-heigh mini-font color-grey bold">RECIPIENT</div>
            <div class="subhead default-heigh">{{clientProfile.contactPerson}}</div>
            <div class="subhead default-heigh">{{clientProfile.phoneNumber}}</div>
            <div class="subhead default-heigh contact-info">{{clientProfile.emailAdress}}</div>
            <div class="subhead default-heigh">{{clientProfile.companyName}}</div>
            <div class="subhead default-heigh">Brand {{clientProfile.brand}}</div>
          </div>
          <div class="summaryQuotation__body__header__summary">
            <div class="default-heigh title mini-font color-grey bold"> CHANNEL SUMMARY</div>
            <div class="subhead default-heigh">{{campaign_list.length}} Channels Campaign</div>
            <div class="subhead default-heigh channel">{{model.totalItem}} Item Channels</div>
            <div class="default-heigh title mini-font color-grey bold "> PERIOD OF CAMPAIGN</div>
            <div class="subhead default-heigh period">Periode {{model.quotationPeriode}}</div>
            <div class="default-heigh title mini-font color-grey bold total-price"> TOTAL PRICE</div>
            <div class="subhead">
              <span class="color-pink strong default-heigh">{{model.totalPrice | formatMoney}}</span>
            </div>
          </div>
        </div>
        <div v-for="(campaign, index) in campaign_list" :key="index" class="summaryQuotation__body__table" >
            <div class="summaryQuotation__body__table__campaign-detail">
              <h1 class="subhead bold default-heigh">{{campaign.name}}</h1>
              <span class="subhead default-heigh title color-grey">Periode {{displayPeriod(campaign.start, campaign.end)}}</span>
            </div>
          <table>
            <thead>
              <tr>
                <td class="col1">ITEMS</td>
                <td class="col2">PERIOD</td>
                <td class="col2">UNIT TYPE</td>
                <td class="col2">UNIT PRICE</td>
                <td class="col3">AMOUNT</td>
              </tr>
            </thead>
            <tbody v-for="(media, index) in campaign.campaign_medias" :key="index">
              <tr v-for="(placement, index) in media.line_item_list" :key="index+`item_detail`" class="content">
                <td class="col1">
                  <div v-if="campaign.channel_name == 'lifestyle'" class="placementGroup">
                    <div class="subhead placement name">{{placement.line_item.location_data.name}}</div>
                    <div class="small-font detail">{{placement.line_item.name}}</div>
                  </div>
                  <div v-else class="placementGroup">
                    <div class="subhead placement name">{{placement.line_item.name}}</div>
                    <div class="small-font detail">{{placement.line_item.location_data.name}}</div>
                  </div>
                </td>
                <td class="col2"><span class="subhead period">{{placement.line_item.min_period}} {{placement.line_item.pricing_unit}}</span></td>
                <td class="col2"><span class="subhead pricing-plan">{{getPricingPlan(placement.line_item.pricing_unit)}}</span></td>
                <td class="col2"><span class="subhead unit-price">
                  {{getAmountPrice(placement.price, placement.line_item.min_period)| formatMoney}}
                  </span>
                </td>
                <td class="col3"><span class="subhead amount">{{ placement.price | formatMoney}}</span></td>
              </tr>
            </tbody>
             <tr class="sub-total-price">
                <td colspan="3" class="col2"></td>
                <td class="col2">Subtotal Price</td>
                <td class="col3">{{getSubTotalPrice(campaign_list[index]) | formatMoney}}</td>
              </tr>
              <tr class="ppn">
                <td colspan="3" class="col2"></td>
                <td class="col2">PPN 10%</td>
                <td class="col3">{{getPPN(getSubTotalPrice(campaign_list[index])) | formatMoney}}</td>
              </tr>
              <tr class="total-price">
                <td colspan="3" class="col2"></td>
                <td class="col2 bold">Total Price</td>
                <td class="col3 bold">
                  {{( getTotalPrice(getSubTotalPrice(campaign_list[index]), getPPN(getSubTotalPrice(campaign_list[index])))) | formatMoney}}
                </td>
              </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api"
import lib from "@/lib/util"
import { apiV2 } from "@/api/urls"
import { helpers } from "@/lib/validation/"
import { mapGetters } from "vuex"
import { constants } from "crypto"
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from "@/lib/mixins/globalMixins";
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AModal, ALoadingSecondary, AListDropdown, ADiscussions,
        ALoadingSecondaryWhite, ASingleSearchDropdown, ALoadingPrimary, AEmptySelection, APagination, ATable} from "ui-kit-v1"

export default {
  name: "adx-quotation-summary",
  components: {
    "adx-loading": ALoadingPrimary,
    "adx-pagination": APagination,
    "adx-dropdown-list": AListDropdown,
    "adx-textarea": ATextArea,
    "adx-table": ATable,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-modal": AModal,
    "adx-discussions": ADiscussions,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      id: null,
      model: {
        quotationName: null,
        clientProfile: null,
        // companyName: null,
        // brand: null,
        // contactPerson: null,
        // emailAdress: null,
        // phoneNumber: null,
        note: null,
        status: null,
        totalPrice: null,
        owner: null,
        issueDate: null,
        totalItem: null,
        quotationPeriode: null,
        number: null
      },
      clientProfile:{
        companyName: '-',
        brand: '-',
        contactPerson: '-',
        emailAdress: '-',
        phoneNumber: '-',
      },
      campaign_list : [],
      campaign_medias: [],
      selectedItem: null,
      campaignId : null,
      itemPrice: null,
      isSelected: false,
      item : null,
      isLoadingMain: false
    };
  },
  computed: {
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    }),
    isLoading: function(){
      return this.isLoadingMain || false
    },
  },
  watch: {

  },
  apollo: {

  },
  beforeCreate() {

  },
  async created() {
  
  },
  async beforeMount() {

  },
  async mounted() {
    this.id = this.$route.params.id
    this.getDetailQuotation()
  },

  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {
    
  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getDetailQuotation(){
      this.isLoadingMain = true
      const {data, status} = await api.get(restEdge.getOneQuotation(this.id), { 
        needToken: true, 
        useRestEdge: true 
      });

      if (status == 200) {
        this.mapData(data)
        this.isLoadingMain = false
      } else {
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }
    },
    mapData(data){

      //mapping quotation detail
      if (data.client_profile_detail != null){
        this.clientProfile.companyName = data.client_profile_detail.company_name ? data.client_profile_detail.company_name : '-'
        this.clientProfile.brand = data.client_profile_detail.brand ? data.client_profile_detail.brand : '-'
        this.clientProfile.contactPerson = data.client_profile_detail.contact_person ? data.client_profile_detail.contact_person : '-'
        this.clientProfile.emailAdress = data.client_profile_detail.email ? data.client_profile_detail.email : '-'
        this.clientProfile.phoneNumber = data.client_profile_detail.phone_number ? data.client_profile_detail.phone_number: '-'
      }
      this.model.quotationName = data.name ? data.name : ''
      this.model.clientProfile = data.client_profile
      this.model.note = data.note ? data.note : '-'
      this.model.status = data.status
      this.model.totalPrice = data.quotation_total_price
      this.model.number = data.number
      this.model.owner = data.owner
      this.model.issueDate =  this.displayPeriod(data.created),
      this.model.quotationPeriode = this.displayPeriod(data.start, data.end)

      //mapping item campaign and price
      this.campaign_list = data.campaign_list ? data.campaign_list : []

      //get total item
     let totalItem = []
      data.campaign_list.map( campaign =>{
        campaign.campaign_medias.map( media =>{
          media.line_item_list.map(line_item =>{
            totalItem.push(line_item)
          })
        })
      })
      this.model.totalItem = totalItem.length
    },
    goToQuotationList() {
      this.$router.push({ name: 'quotationlist'});
    },
    displayPeriod(startDate, endDate) {
      if(startDate && endDate ){
        return `${lib.formatShortDate(startDate)} - ${lib.formatShortDate(endDate) }`
      }else{
        return `${lib.formatShortDate(startDate)}`
      }
    },
    goEditQuotation(){
      this.$router.push({ name: 'quotationedit', params: {id: this.id} });
    },
    getPricingPlan(plan){
      switch(plan){
        case `month`:
          return 'Monthly'
          break;
        case `week`:
          return 'Weekly'
          break;
        case `day`:
          return 'dayly'
          break;
      }
    },
    getPPN(price){
      return price * 0.1
    },
    getTotalPrice(ppn, price){
      return ppn + price
    },
    getAmountPrice(price, period){
      return price / period
    },
    getSubTotalPrice(campaignList){
      let channel  = campaignList.channel_name
      let totalItem = []
      let subTotalPrice = 0
      campaignList.campaign_medias.map( media => {
        media.line_item_list.map( item => {
          if(media.period){
            totalItem.push({
              item : item,
              period : media.period 
              })
          } else if(media.cycle){
            totalItem.push({
              item : item,
              period : media.cycle 
            })
          } else {
            totalItem.push({
              item : item,
              period : media.duration 
            })
          }
        })
      })

      if(totalItem.length > 0){
        totalItem.map(placement => {
          subTotalPrice += (placement.item.price * placement.period) 
        })
      }
      return subTotalPrice
    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
<style lang='scss'>

</style>
